import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EnviarEmailContatoState } from '../reducers/enviar-email-contato.reducer';

export const selectEnviarEmailContatoState = createFeatureSelector<EnviarEmailContatoState>('enviarContato');

export const selectDadosEnviarEmailContato = createSelector(
    selectEnviarEmailContatoState,
    (state: EnviarEmailContatoState) => state.response
);

export const selectEnviarEmailContato = createSelector(
  selectEnviarEmailContatoState,
  (state: EnviarEmailContatoState) => state
);

export const selectErrosEnviarEmailContato = createSelector(
    selectEnviarEmailContatoState,
    (state: EnviarEmailContatoState) => state.error
);
